<loader *ngIf='datasetACS.loading.value'></loader>

<ng-container *ngIf='!datasetACS.loading.value'>
	<ng-container [ngSwitch]='datasetACS.datasetCode'>
		<app-tour 
			*ngSwitchCase='"trip_packages"'
			[preview]='_response'
		></app-tour>

		<product-detail-page
			*ngSwitchCase='"products"'
			[preview]='_response'
		></product-detail-page>

		<div *ngSwitchDefault>Nessun componente configurato per il dataset code {{datasetACS.datasetCode}}.</div>
	</ng-container>
</ng-container>
